import { ReactElement } from 'react'
import { thousandsSeparator, useTranslate } from 'utils'
import { CircularSign, Content, StatItem, StatsWrapper, Title } from './analytics-stats.style'

type AnalyticsStatsProps = {
    totalAppointments: number
    totalSales: string
    currency: string
}

export const AnalyticsStats = ({
    totalAppointments,
    totalSales,
    currency
}: AnalyticsStatsProps): ReactElement => {
    const { __ } = useTranslate()

    return (
        <StatsWrapper>
            <StatItem>
                <Title>{ __`appointments` }</Title>
                <Content>
                    <CircularSign color='#ad8bfc'></CircularSign>
                    {thousandsSeparator(totalAppointments)}
                </Content>
            </StatItem>
            <StatItem>
                <Title>{ __`sales` }</Title>
                <Content>
                    <CircularSign color='#1dd9e3'></CircularSign>
                    {totalSales} {currency || ''}
                </Content>
            </StatItem>
        </StatsWrapper>
    )
}
